import { getErrorObject } from '../../shared/error/GlobalError';
import { showErrorModal } from '../../shared/store/errorSlice';
import { hideLoader } from '@shared/store/loaderSlice';
import { GlobalError } from './GlobalErrorprops';

/**
 * This function is used to handle the global errors and display the modal
 * @param {error}  - error response object
 */
export const globalErrorHandler = async ({error, dispatch, isFromRepairDetails}: GlobalError) => {
  const errorStatus = error?.status?.toString();
  const errorMsg = error?.data?.message?.toString();

  const errorMessage = await getErrorObject({
    message: errorMsg,
    status: errorStatus,
    isFromRepairDetails
  });
  if (errorMessage) {
    dispatch?.(hideLoader());
    setTimeout(() => {
      dispatch?.(showErrorModal(errorMessage));
    }, 500);
  }
};
